// extracted by mini-css-extract-plugin
module.exports = {"noDataContainer":"ChartsTable_noDataContainer__ZX7rw","tableContainer":"ChartsTable_tableContainer__2Z28p"};